import React, { useState, useEffect, useCallback } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Input, Select } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import dayjs from "dayjs";
import { Badge } from "../../../../../components/Elements/TextStyles/Badge";
import { ReactComponent as EditIcon } from "../../../../../assets/svgs/edit-green.svg";
import { useNavigate } from "react-router-dom";

const ProjectFilter = ({
  onOpen,
  onClose,
  setFilterData,
  filterData,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  status,
  setStatus,
  projectType,
  setProjectType,
}) => {
  // const [startDate, setStartDate] = useState(filterData?.startDate || "");
  // const [endDate, setEndDate] = useState(filterData?.endDate || "");
  // const [status, setStatus] = useState(filterData?.status || "");
  // const [projectType, setProjectType] = useState(
  //   filterData?.projectType || null,
  // );
  const [isStartFocused, setIsStartFocused] = useState(false);
  const [isEndFocused, setIsEndFocused] = useState(false);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();

  const handleForm = useCallback(
    (item) => {
      navigate("/organization/projects/projectPage", {
        state: { projectName: item.name, projectId: item._id },
      });
    },
    [navigate],
  );

  const handleSave = async () => {
    const filter = {};
    // const filter = {
    //   startDate,
    //   endDate,
    //   status,
    //   projectType,
    // };
    if (startDate) filter.startDate = startDate;
    if (endDate) filter.endDate = endDate;
    // projectType is labelInValue ({ label, value }); if 'ALL' selected, omit from payload
    if (projectType && projectType.value !== "ALL") {
      filter.projectType = projectType.label;
    }
    // status: if 'All' selected, omit from payload
    if (status && status !== "All") {
      filter.status = status;
    }

    setFilterData(filter);
    onClose();
  };

  const fetchProjectTypes = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_PROJECT_TYPES(pageSize),
      });
      if (response.success) {
        const types = response.data.data
          .filter((item) => item.status !== "Inactive")
          .map((item) => ({
            label: item.project_type,
            value: item._id,
          }));
        setProjectTypeOptions(types);
      }
    } catch (error) {
      console.error("Error fetching project types:", error);
    } finally {
    }
  };

  // const fetchProjectTypes = async (page = 1, size = pageSize) => {
  //   try {
  //     const response = await getApi({
  //       apiUrl: API_URLS.GET_ALL_PROJECT_TYPES(size, (page - 1) * size), // Assuming offset-based pagination
  //     });

  //     if (response.success) {
  //       const types = response.data.data.map((item) => ({
  //         label: item.project_type,
  //         value: item._id,
  //       }));
  //       setProjectTypeOptions(types);

  //       // Set pagination metadata from the API response
  //       const { metadata } = response.data;
  //       setTotalItems(metadata.total);
  //       setTotalPages(metadata.totalPages);
  //       setCurrentPage(metadata.page);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching project types:", error);
  //   }
  // };

  const handleCancel = () => {
    setStartDate("");
    setEndDate("");
    setProjectType(null);
    setStatus("");
    setIsStartFocused(false);
    setIsEndFocused(false);
    setFilterData("");
    onClose();
  };

  useEffect(() => {
    fetchProjectTypes();
  }, []);

  // useEffect(() => {
  //   if (onOpen) {
  //     setStartDate(filterData?.startDate || "");
  //     setEndDate(filterData?.endDate || "");
  //     setStatus(filterData?.status || "");
  //     setProjectType(filterData?.projectType || null);
  //   }
  // }, [onOpen, filterData]);

  useEffect(() => {
    fetchProjectTypes();
  }, []);
  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className=" text-xl">Filter</h3>
        </div>

        <div className="flex justify-between gap-10 mt-10">
          <div className="flex flex-col w-full">
            <Input
              type={isStartFocused ? "date" : "text"}
              value={
                isStartFocused
                  ? startDate
                  : startDate
                    ? dayjs(startDate).format("DD-MM-YYYY")
                    : ""
              }
              onFocus={() => setIsStartFocused(true)}
              onBlur={(e) => {
                if (!e.target.value) setIsStartFocused(false);
              }}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="Start Date"
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "10px",
              }}
              className="text-base font-light h-14"
            />
          </div>

          <div className="flex flex-col w-full">
            <Input
              type={isEndFocused ? "date" : "text"}
              value={
                isEndFocused
                  ? endDate
                  : endDate
                    ? dayjs(endDate).format("DD-MM-YYYY")
                    : ""
              }
              onFocus={() => setIsEndFocused(true)}
              onBlur={(e) => {
                if (!e.target.value) setIsEndFocused(false);
              }}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="End Date"
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "10px",
              }}
              className="text-base font-light h-14"
            />
          </div>
        </div>
        <div className="flex justify-between gap-10 mt-10">
          <div className="flex flex-col w-full">
            <Select
              showSearch
              labelInValue
              value={projectType || undefined}
              onChange={(valueObj) => setProjectType(valueObj)}
              placeholder="Project Services"
              className="text-lg font-light h-14"
              allowClear
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              <Select.Option value="ALL">All</Select.Option>
              {projectTypeOptions.map((type) => (
                <Select.Option key={type.value} value={type.value}>
                  {type.label}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="flex flex-col w-full">
            <Select
              value={status || undefined}
              onChange={setStatus}
              placeholder="Status"
              allowClear
              className="text-base font-light h-14"
            >
              <Select.Option value="All">All</Select.Option>
              <Select.Option value="Project Created">
                Project Created
              </Select.Option>
              <Select.Option value="Project Setup Completed">
                Project Setup Completed
              </Select.Option>
              <Select.Option value="Form Submission in Progress">
                Form Submission in Progress
              </Select.Option>
              <Select.Option value="Forms Submitted">
                Forms Submitted
              </Select.Option>
              <Select.Option value="Report Requested">
                Report Requested
              </Select.Option>
              <Select.Option value="Report Generated">
                Report Generated
              </Select.Option>
              <Select.Option value="Audit Requested">
                Audit Requested
              </Select.Option>
              <Select.Option value="Audit in Progress">
                Audit in Progress
              </Select.Option>
              <Select.Option value="Audit Completed">
                Audit Completed
              </Select.Option>
            </Select>
          </div>
        </div>

        <div className="flex justify-center gap-4 py-6">
          <CustomButton
            buttonType="primary"
            variant="cancel"
            buttonText="Reset"
            className="text-sm px-6 py-2 rounded-lg"
            onClick={handleCancel}
          />
          <CustomButton
            buttonType="primary"
            variant="ok"
            buttonText="Search"
            className=" text-sm px-6 py-2 rounded-lg"
            onClick={handleSave}
          />
        </div>
      </DialogBox>
    </div>
  );
};

export default ProjectFilter;
